import React from "react";
import Body from "./Body";
import Users from "../Users/Users";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";

const UsersPage = () => {
  const { token } = useSelector((state) => state.users);

  if (!token) {
    return <Redirect to='/login' />;
  } else {
    return (
      <Body state={1}>
        <Users />
      </Body>
    );
  }
};

export default UsersPage;
